export const MoveFocusToElement = (elementId: string | undefined = 'root') => {
	if (elementId) {
		const createInterventionButton = document.getElementById(elementId);
		createInterventionButton?.setAttribute('tabindex', '1');
		createInterventionButton?.focus();
		createInterventionButton?.removeAttribute('tabindex');
	}
};
